// Display preferences in Account Settings › Account details (PROD-3313, Andrew's review: times were 24-hour with no
// toggle). Ported from dev-scrips-pm-react `src/settings/pages/account-details-page.tsx` `TimeFormatField` (its
// "Display" card, Antonin 13 Oct). PM draws a hand-rolled radio pill; here it is the DS `Segmented` (a radiogroup),
// the light `pill` variant. It is the viewer's own preference, kept in this browser (`shared/lib/time-format.ts`), so
// it shows on the self-edit (account mode) tab of both the practitioner and the nurse.
import { FieldLabel, Segmented, type SegmentedOption } from '@scripsteam/scrips-signal-ds';
import { useTimeFormat, useTimeFormatStore, type TimeFormat } from '@/shared/lib/time-format';
import { SETTINGS_SECTION_TITLE } from '@/settings/components/settings-look';

const TIME_FORMAT_OPTIONS: SegmentedOption<TimeFormat>[] = [
  { value: '12h', label: '12-hour · 1:45p' },
  { value: '24h', label: '24-hour · 13:45' },
];

export function DisplayPreferencesSection() {
  const format = useTimeFormat();
  const setFormat = useTimeFormatStore((s) => s.setFormat);
  return (
    <>
      <h2 className={SETTINGS_SECTION_TITLE}>Display</h2>
      <section
        data-slot="settings-display"
        className="rounded-lg border border-border-hairline bg-surface-card shadow-1 px-6 py-6 flex flex-col gap-2"
      >
        <FieldLabel stacked>Time format</FieldLabel>
        <Segmented<TimeFormat>
          variant="pill"
          aria-label="Time format"
          options={TIME_FORMAT_OPTIONS}
          value={format}
          onChange={setFormat}
        />
        <p className="text-sm text-text-muted">
          How times show across the calendar and appointments. Saved in this browser.
        </p>
      </section>
    </>
  );
}
